module.exports = __webpack_public_path__ + "media/images/lb/855-3e19f86466ec977820f470d09af9b395.svg";